module.exports = __webpack_public_path__ + "static/front-runners-0c95d223c7b9db7a9d82b4870d794b1e.png";